import useDynamicForm from '@hook/useDynamicForm'
import Buttons from '@ui/elements/Buttons'
import Div from '@ui/layout/Div'
import { useTranslation } from 'react-i18next'

const Commands = () => {
  const toggleDynamicForm = useDynamicForm()
  const [t] = useTranslation('permissions')

  return (
    <Div cssClass='actions-zone'>
      <Buttons buttons={[
        {
          icon: 'icon-add',
          cssClass: 'is-info is-small',
          callback: () => toggleDynamicForm('userRole'),
          text: t('actions.add_role')
        }, {
          icon: 'icon-add',
          cssClass: 'is-info is-small',
          callback: () => toggleDynamicForm('permissionSubject'),
          text: t('actions.add_subject')
        }
      ]} />
    </Div>
  )
}

export default Commands